(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-banner-top"] && !window.DesignMode) return;
  try {
    
jQuery(document).ready(function($){
  $(".mobile-collection-slider").slick({slidesToShow:5,slidesToScroll:1,autoplaySpeed:1e3,prevArrow:!1,nextArrow:!1,
                                        arrows: true,
      autoplay: true,
      prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></i></button>',
                                        responsive:[{breakpoint:768,settings:"unslick"},{breakpoint:1024,settings:"unslick"},{breakpoint:767,settings:{slidesToShow:2,slidesToScroll:1,infinite:false,prevArrow:'<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="19" height="34" viewBox="0 0 19 34"> <g fill="none" fill-rule="evenodd"> <g stroke="#fff"> <g> <path d="M222 350L205 367 222 384" transform="translate(-204.000000, -4159.000000) translate(0.000000, 3809.000000)"/> </g> </g> </g></svg></button>',nextArrow:'<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="19" height="34" viewBox="0 0 19 34"> <g fill="none" fill-rule="evenodd"> <g stroke="#fff"> <g> <path d="M1234 350L1217 367 1234 384" transform="translate(-1216.000000, -4159.000000) translate(0.000000, 3809.000000) translate(1225.500000, 367.000000) scale(-1, 1) translate(-1225.500000, -367.000000)"/> </g> </g> </g></svg></button>'}}]});
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation"]) return;
  try {
    
  $(document).ready(function(){
$('body').on('click','.buylook1',function(e){
    e.preventDefault();
    var variant_id = $(this).closest('form').find('select[name="id"]').val();
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: variant_id
        },
        dataType: 'json', 
        success: function (data) { 
          $.getJSON('/cart.json', function(cartdata) {
            $('.cartToggle .cartCount').html(cartdata.item_count);
            $('.cart_views .cartCount').html(cartdata.item_count);
            
            if(cartdata.item_count>0){
            $('.has-items').show();
            $('.no-items').hide();
          
            }
                $('.mini-products-list').empty();
                    var TPrice = cartdata.total_price / 100; 
                TPrice = TPrice.toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'GBP',
                });
              
    $('#dropdown-cart').find('.price').html(TPrice);                 
            $.each(cartdata.items, function(index, val) {
                var productImage = val.image;
                var productUrl = val.url;
                var productName = val.product_title;
                var productQuantity = val.quantity;
                    var productPrice = val.price / 100; 
                productPrice = productPrice.toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'GBP',
                });
                var cartItemHtml = `<li class="item" id="cart-item-${val.id}" proId="${val.id}">
                <a href="${productUrl}" class="product-image">
                <img src="${productImage}" alt="${productName}"></a>
                    <div class="product-details"><a href="javascript:void(0)" title="Remove" id="removeProduct" class="btn-remove"><!--?xml version="1.0" encoding="iso-8859-1"?-->
    <svg class="icon-close" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g><g>
        <polygon points="512,59.076 452.922,0 256,196.922 59.076,0 0,59.076 196.922,256 0,452.922 59.076,512 256,315.076 452.922,512 
          512,452.922 315.076,256 		"></polygon></g></g></svg></a><p class="product-name"><a href="£{productUrl}">
                          <span>${productName}</span>
                        </a>
                                          </p>
                      <div class="cart-collateral">
                        <span class="qtt">${productQuantity} X</span>
                        <span class="price">
                          <span class="transcy-money">${productPrice}</span>
                        </span>
                      </div>
                    </div>
                  </li>`;
              $('ol.mini-products-list').append(cartItemHtml);
              });  
          });
      
        } 
      });
    });
  })

  } catch(e) { console.error(e); }
})();
})();
